module.exports = __webpack_public_path__ + "static/media/Checkins.ba40724f.svg";